import { injectGlobal } from 'styled-components';

injectGlobal`
    body{
        background: #fff;
        overflow: hidden;
    }

    a {
        color: #007acc;
        text-decoration: none;
        box-shadow: none;
        border-bottom: 1px solid transparent;
        transition: all ease-in-out 0.3s;
        
        &:hover{
            color: #007acc !important;
            text-decoration: none !important;
            border-color: #007acc;
        }
    }

    /* change navbar background on collapse */
    @media (max-width: 575px) {
        nav.navbar {
            background-color: #fff !important;
        }
    }

    .post {
        ul,ol {
            padding-left: 20px !important;
        }
    }
}
`


// WEBPACK FOOTER //
// ./src/utils/globalstyle.js